module.exports = __webpack_public_path__ + "media/CN_004.bd5d98cd.mp3";